import { getUser } from '../AppServices';
import { MODELS } from '../Lib/constants';

export const listUri = ({ filter = {}, params } = {}) => {
  return {
    query: {
      id: 'listQuery',
    },
    aggregate: true,
    model: MODELS.AVRulesModel,
  };
};

export const dealerListUri = ({ filter = {}, params } = {}) => {
  const user = getUser();
  return {
    query: {
      id: 'listQuery',
      addOnFilter: { madeByName: user?.dealer?.username },
    },
    aggregate: true,
    model: MODELS.AVRulesModel,
  };
};

export const editRuleUri = ({ navigation }) => ({
  query: {
    model: MODELS.AVRulesModel,
    id: 'getRuleDetails',
    relationValue: {
      model: MODELS.AVRulesModel,
      _id: navigation?.state?.params?.item?._id,
      relation: '_id',
    },
    limit: 1,
  },
  model: MODELS.AVRulesModel,
});

export const addRuleUri = ({ navigation }) => ({
  query: {
    model: MODELS.AVRulesModel,
    id: 'getRuleDetails',
    relationValue: {
      model: MODELS.AVRulesModel,
      _id: navigation?.state?.params?.saveId,
      relation: '_id',
    },
    limit: 1,
  },
  model: MODELS.AVRulesModel,
});
